













import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {DeviceFileCacheService, WebService} from '../services/';

/**
 * caches the given or wrapped img
 *
 * Caching works only on devices, using Capacitor.
 *
 * There is no need to call WebService.assetPath on values passed to src,
 * but those values are also accepted.
 */
@Component
export default class CachedImage extends Vue {
	@Prop({default: ''})
	alt!: string;

	@Prop({required: true})
	src!: string | null | undefined;

	cachedSrc = '';

	@Watch('src', {immediate: true})
	async getCachedImage() {
		if(typeof this.src === 'string') {
			try {
				const result = await DeviceFileCacheService.get(this.src);
				if(result) {
					this.cachedSrc = result;
				} else {
					throw new Error('Failed to determine image src');
				}
			} catch(e) {
				console.warn(`Unable to determine cached src for ${this.src}.`, e);
				this.cachedSrc = WebService.assetPath(this.src) ?? '';
			}
		}
	}


	handleError(event: Event) {
		console.debug(`CachedImage received an error trying to load ${this.src}.`);
		this.cachedSrc = '';
		this.$emit('error', event);
	}
}
